import { FAQS } from "@/data/faqs";
import SEO from "@/components/SEO";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ() {
  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
  return (
    <div data-testid="faq-page">
      <SEO
        title="FAQ — Independent Environmental Assessments"
        description="Honest answers to common questions about mold assessments, indoor air quality, water damage categories, sampling, standards, and Hurtler Environmental's independence."
        path="/faq"
        jsonLd={faqJsonLd}
      />
      <section className="bg-[#0F172A] text-white py-24">
        <div className="container-x max-w-4xl">
          <div className="overline text-[#F59E0B] mb-5">Frequently asked</div>
          <h1 className="font-display text-5xl sm:text-6xl font-extrabold tracking-tight leading-[1.05]">
            Honest answers to common questions.
          </h1>
        </div>
      </section>
      <section className="section-pad bg-white">
        <div className="container-x max-w-3xl">
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="card-soft px-6 border"
              >
                <AccordionTrigger className="text-left font-display font-bold text-[#0F172A] text-lg py-5 hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed text-base pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </div>
  );
}
